module.exports = __webpack_public_path__ + "img/splish.52161425.jpg";